// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"assets_i18n_en_translation_json":"8766503afce9230ecf76","assets_i18n_nl_translation_json":"092dbdde0c348b792ed3"}[chunkId] + ".chunk.js";
};